/**
 * The pages someone reaches WITHOUT signing in to Console — the one list.
 *
 *   buyers' and partners' links   /sign/…, /id/…, /confirm-email/…, /review/…,
 *                                 /worksheet-response/…, /documents
 *                                 (shared/purchaseHost.ts, the purchase host's list)
 *   public pages                  /register/…, /quote/…, /roadmap/…,
 *                                 /privacy-policy, /terms-of-use,
 *                                 /unsubscribe/… (a buyer leaving Livvy's emails)
 *   Console framed in a Showroom  /embed/…
 *
 * Five places kept their own copy and they drifted: the sign-in return-to
 * (lib/sessionEnd.ts) and AuthContext's "bounced off a protected page" knew
 * none of the buyer links, so a rep who opened a purchaser's signing link
 * while signed out, then signed in, was sent back to the buyer's page
 * (audit, 2026-10-27). App's public-route test, the 401 handler and
 * AuthContext all read this now; tests/publicPages.test.ts pins it.
 */
import { isBuyerPath } from "@shared/purchaseHost";

const PUBLIC_PAGES = ["/register", "/quote", "/roadmap", "/privacy-policy", "/terms-of-use", "/embed", "/unsubscribe"] as const;

/** A path (query and hash ignored) that is a public or buyer-facing page. */
export function isPublicPagePath(path: string): boolean {
  const pathname = path.split(/[?#]/)[0] || "/";
  if (isBuyerPath(pathname)) return true;
  return PUBLIC_PAGES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
